export class Stammdaten {
  [key: string]: string | Date | Blob;
  public aktualisiertUtc!: Date;
  public angelegtUtc!: Date;
  public email!: string;
  public gebdat!: string;
  public id!: string;
  public nachname!: string;
  public personalnummer!: string;
  public token!: string;
  public vorname!: string;
}
